import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

import Action from '@/components/Action';
import Alert from '@/components/Alert';
import Button from '@/components/Button';
import Card from '@/components/Card';
import Modal from '@/components/Modal';
import Stack from '@/components/Stack';
import { Body } from '@/components/Typography';

type Props = {
  orderId: number | string;
  hideModal: () => void;
  hireMessage?: string | null;
  // GRAVY-10803. Order Flow V2 delegates to the same backend service as the
  // legacy wizard, so it runs the same badge gate: a worker who lacks a badge
  // the job requires is refused while the order itself still succeeds. Without
  // this the admin lands on "Order placed!" and the worker is simply absent.
  staffingErrors?: string[];
};

const PostSubmitModal = ({
  orderId,
  hideModal,
  hireMessage,
  staffingErrors = [],
}: Props) => {
  return (
    <Modal
      disableClickout
      size="xs"
      title={`Order #${orderId} placed!`}
      wrapperBackground={true}
      onRequestClose={hideModal}
    >
      <Card.Section>
        <Stack vertical gap={24}>
          <Body>Your order #{orderId} was successfully placed.</Body>
          {hireMessage ? <Body>{hireMessage}</Body> : null}
          {staffingErrors.length > 0 && (
            <Alert
              data-testid="post-submit-staffing-errors"
              description={staffingErrors.join(' ')}
              icon={faExclamationTriangle}
              status="warning"
              title={
                staffingErrors.length === 1
                  ? 'One worker was not hired'
                  : `${staffingErrors.length} workers were not hired`
              }
            />
          )}
          <Stack justify="end">
            <Button
              a11yLabel="Start a new order"
              appearance="outline"
              id="start-new-order"
              label="Place another"
              onClick={hideModal}
            />
            <Action.Button
              action={{
                a11yLabel: 'Navigate to order page',
                id: 'view-order-btn',
                label: 'View order',
                to: `/orders/${orderId}`,
              }}
              appearance="primary"
            />
          </Stack>
        </Stack>
      </Card.Section>
    </Modal>
  );
};

export default PostSubmitModal;
